module.exports = __webpack_public_path__ + "assets/retina_RhombusInRectDetailed.039082b751f9fb720cc0842986aabbf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_RhombusInRectDetailed.png
// module id = 709
// module chunks = 0